var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingSection4Card3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.63501,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FEBA05",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1252 15.5351V21.9726C29.1252 25.8226 26.9252 27.4726 23.6252 27.4726H12.6377C12.0752 27.4726 11.5377 27.4227 11.0377 27.3102C10.7252 27.2602 10.4252 27.1727 10.1502 27.0727C8.2752 26.3727 7.1377 24.7476 7.1377 21.9726V15.5351C7.1377 11.6851 9.33769 10.0352 12.6377 10.0352H23.6252C26.4252 10.0352 28.4377 11.2227 28.9752 13.9352C29.0627 14.4352 29.1252 14.9476 29.1252 15.5351Z",
    stroke: "#FEBA05",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8766 19.2853V25.7228C32.8766 29.5728 30.6766 31.2227 27.3766 31.2227H16.3891C15.4641 31.2227 14.6266 31.0978 13.9016 30.8228C12.4141 30.2728 11.4016 29.1353 11.0391 27.3103C11.5391 27.4228 12.0766 27.4727 12.6391 27.4727H23.6266C26.9266 27.4727 29.1266 25.8228 29.1266 21.9728V15.5353C29.1266 14.9478 29.0766 14.4228 28.9766 13.9353C31.3516 14.4353 32.8766 16.1103 32.8766 19.2853Z",
    stroke: "#FEBA05",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1233 22.06C19.9458 22.06 21.4233 20.5825 21.4233 18.76C21.4233 16.9374 19.9458 15.46 18.1233 15.46C16.3007 15.46 14.8232 16.9374 14.8232 18.76C14.8232 20.5825 16.3007 22.06 18.1233 22.06Z",
    stroke: "#FEBA05",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9756 16.01V21.51",
    stroke: "#FEBA05",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2773 16.0105V21.5105",
    stroke: "#FEBA05",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingSection4Card3);
export default __webpack_public_path__ + "static/media/landing_section4_card3.debc3a88c549831e2a8c70520ee24fe5.svg";
export { ForwardRef as ReactComponent };